export const SubscriptionItemRemovalExperiment = {
  TEST_ID: 'b7e91d330fbea0e29ad20d754fd7de52e398fadf9797b7ea875ec8afb29946f6',
  name: 'Subscription Item Removal',
};
export const CartOptimizationPhase2Experiment = {
  TEST_ID: '9a96ef0341501294527e81bb7b6a92cf8a8dd385cfafb5691659fe7a08589801',
  name: 'cart_optimization_product_card_pricing',
};
export const PostPurchaseInterstitialSssExperiment = {
  TEST_ID: '835fae7a04793ae0071988b45c7ee7522b5c5bcaafeab423c2cfb49551e28f96',
  name: 'post-purchase-interstitial-sss-ab-test',
};
export const CartOptimizationPhase3Experiment = {
  TEST_ID: 'ca9e246704d4b2b3c5587727fb926b398d452467aa6f4ba09a8e8489e7083226',
  name: 'order_summary_checkout_info_optimization',
};
export const PdpRevampShampooExperiment = {
  TEST_ID: '7a0973f4d9a18db238788b696cf91a541f05944cacd1c6d0ee24dbad37bf4f01',
  name: 'pdp-revamp-shampoo',
};
export const HairConsultationFirstQuestionExperiment = {
  TEST_ID: '18ca189d8c98fcec62ba5379a57956daf52673ebb3a5556b3f0fd17810713333',
  name: 'hair_consultation_first_question',
};
export const HaircareSubscriptionFrequencyExperiment = {
  TEST_ID: 'd1a8949e0d92964a41c627bfb983764fc7ed1bb2800a21003e35dd8f717c6c07',
  name: 'haircare-subscription-frequency-ab-test',
};
